import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "商品開発支援SaaS「Coreka」のUX/UI設計を全面支援。OOUI・ブランドアーキタイプ・ベリーピッキングモデルを活用した論理的な設計アプローチで、「マニュアルなしで直感的に使える」とユーザーから高評価を獲得したマクロミルの事例です。"

const primaryImage = `${SITE_URL}/images/img/cases/coreka/ogp_coreka.png`

export const corekaPageMeta: PageMeta = {
  title: "マクロミル「Coreka」マニュアル不要のSaaS UX/UI設計支援事例 | i3DESIGN",
  description,
  keyword: "Coreka コレカ UIUX オブジェクト指向UI OOUI ブランドアーキタイプ",
  image: primaryImage,
  url: `${SITE_URL}/cases/coreka/`,
}

export const corekaSchema = buildCaseStudySchema({
  slug: "coreka",
  pageTitle: corekaPageMeta.title,
  description: corekaPageMeta.description,
  headline: "マニュアル不要の市場調査・分析SaaS開発を実現",
  alternativeHeadline: "株式会社マクロミル",
  primaryImage,
  images: [primaryImage, `${SITE_URL}/images/img/cases/coreka/mv.webp`],
  clientName: "株式会社マクロミル",
  breadcrumbLabel: "マニュアル不要の市場調査・分析SaaS開発を実現",
})
